export const toSnakeCase = (string: string) => {
  if (!string) return '';
  return string
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
};
